import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { API_URLS, CONSTANTS } from '../global';
import { DevModeService } from './dev-mode.service';
import { HttpClient } from '@angular/common/http';
import { LocateMeRenderingResponse } from '../models/locate-me-rendering-response';
import { ZipcodeService } from './zipcode.service';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  dyeventCalled: boolean =false;
  renderingData!: LocateMeRenderingResponse;
  renderingDataSubject = new Subject<LocateMeRenderingResponse>();

  zipCodeFromUrl!: null | string;

  constructor(
    private readonly devModeService: DevModeService,
    private readonly http: HttpClient,
    private readonly zipcodeService: ZipcodeService
  ) {
    this.locateMeRendering().subscribe(response => {
      this.renderingDataSubject.next(response);
    });

    document.addEventListener(CONSTANTS.UPDATE_ZIPCODE_EVENT, (event: any) => {
      if (event.detail.zipcode) {
        this.renderingData.LocateMeData.PreferredZipCode = event.detail.zipcode;
        this.renderingDataSubject.next(this.renderingData);
      }
    });

    console.log('@@@ Loading lib: @autonation/dt-an-zipcodewidget-lib@0.0.59');
  }

  locateMeRendering(): Observable<LocateMeRenderingResponse> {
    if (this.renderingData) {
      this.dyeventCalled = false;
      return of(this.renderingData);
    } else {      
      this.dyeventCalled = true;
      const url = this.devModeService.isDevMode() ? API_URLS.LOCAL + API_URLS.LOCATE_ME_RENDERING : API_URLS.LOCATE_ME_RENDERING;
      return this.http.get(url, { responseType: 'text' }).pipe(
        map(response => {
          try {
            this.renderingData = this.parseJsonString(response);
            this.zipCodeFromUrl = this.getZipCodeFromUrl();
            console.log('Getting zipcode from URL: ', this.zipCodeFromUrl);
            if (this.zipCodeFromUrl) {
              //Update zipcode
              if (this.renderingData.LocateMeData.PreferredZipCode != this.zipCodeFromUrl) {                
                this.zipcodeService.updateZipcode(this.zipCodeFromUrl).subscribe();
              }
              this.renderingData.LocateMeData.PreferredZipCode = this.zipCodeFromUrl;
            }
            console.log('@Zipcode modal: loading rendering data', this.renderingData);
            return this.renderingData;
          } catch (error) {
            console.error(error);
            throw error;
          }
        }),
        catchError(err => of(err))
      );
    }
  }

  parseJsonString(jsonString: string): LocateMeRenderingResponse {
    const value = jsonString.replace(new RegExp('&q;', 'g'), '"')
      .replace(new RegExp('&a;', 'g'), '&')
      .replace(new RegExp('&s;', 'g'), '\'')
      .replace(new RegExp('&l;', 'g'), '<')
      .replace(new RegExp('&g;', 'g'), '>');
    return JSON.parse(value);
  }

  reloadPage(zipcode: string): void {
    if (this.getZipCodeFromUrl()) {
      let newUrl = new URL(document.location.toString());
      newUrl.search = new URLSearchParams({ zip: zipcode }).toString();
      document.location.href = newUrl.href;
    } else {
      document.location.reload();
    }
  }

  getZipCodeFromUrl(): string | null {
    return this.isSRP && this.urlParams.has('zip') ? this.extractZipCode(this.urlParams.get('zip')) : null;
  }

  private extractZipCode(value: string | null): string {
    if(value) {
      const result = /(^\d{5})/.exec(value);
      return result ? result[0] : '';
    } else {
      return '';
    }
  }

  get urlParams(): URLSearchParams {
    return new URLSearchParams(document.location.search);
  }

  get isSRP(): boolean {
    return document.location.pathname.indexOf('/cars-for-sale') === 0;
  }

  identifyLocationEvent(zipcode: string | undefined): void {
    console.log('dyeventCalled', this.dyeventCalled);
    if(this.dyeventCalled) {
      this.dyeventCalled = false;
      const w = (window as any);
      if (typeof w.dytag_data === 'undefined' || !w.dytag_data || typeof w.DY === 'undefined') return;
  
      const _latitude = typeof w.dytag_data["maxmind_location.latitude"] === 'undefined'
        ? w.dytag_data.Latitude
        : w.dytag_data["maxmind_location.latitude"];
  
      const _longitude = typeof w.dytag_data["maxmind_location.longitude"] === 'undefined'
        ? w.dytag_data.Longitude
        : w.dytag_data["maxmind_location.longitude"];
  
      const _zipcode = zipcode ? zipcode : "not set";
  
      console.log('@@@ - DY Identify location event - zipcodeV2 ');
  
      w.DY.API("event", {
        name: 'Identify Location',
        properties: {
          latitude: _latitude,
          longitude: _longitude,
          zipcode: _zipcode
        }
      });
    }
  }
}
